import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function getBeneficiaries ({token_auth, rfc, name, middle_name, paternal_name, maternal_name}) {
    
  const resource = `/fas/beneficiary_update_request/get_list_beneficiaries`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    name: name,
    middle_name: middle_name,
    paternal_name: paternal_name,
    maternal_name: maternal_name
  }
  
  return get(API_URL, { params, config })
}

function register ({token_auth, rfc, name, middle_name, paternal_name, maternal_name, tutor, email, beneficiaries_list_json}) {
  const resource = `/fas/beneficiary_update_request/create`
  const API_URL = `${host}${resource}`

  const config = {
      headers: {
      "Content-Type": "application/json",
      }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    name: name,
    middle_name: middle_name,
    paternal_name: paternal_name,
    maternal_name: maternal_name,
    tutor: tutor,
    email: email,
    beneficiaries_list_json: beneficiaries_list_json
  };

  return post(API_URL,  params, config )
}

function getPendingRequest (token_auth, rfc) {
    
  const resource = `/fas/beneficiary_update_request/get_pending_by_rfc`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc
  }
  
  return get(API_URL, { params, config })
}

function uploadFile (token_auth, beneficiary_update_request_id, file) {
    
  const resource = `/fas/beneficiary_update_request/load_document`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    beneficiary_update_request_id: beneficiary_update_request_id,
    file: file
  }
  
  return post(API_URL,  params, config )
}

function cancelRequest (token_auth, id) {
    
  const resource = `/fas/beneficiary_update_request/cancel`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }
  
  return post(API_URL,  params, config )
}

function acceptRequest (token_auth, id) {
    
  const resource = `/fas/beneficiary_update_request/accept`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }
  
  return post(API_URL,  params, config )
}

function rejectRequest (token_auth, id) {
    
  const resource = `/fas/beneficiary_update_request/reject`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }
  
  return post(API_URL,  params, config )
}

function getUploadedDocumentRequest (token_auth, rfc) {
    
  const resource = `/fas/beneficiary_update_request/get_requests_with_upload_document_by_rfc`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc
  }
  
  return get(API_URL, { params, config })
}

function getAllRequest (token_auth) {
    
  const resource = `/fas/beneficiary_update_request/get_all`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth
  }
  
  return get(API_URL, { params, config })
}
    
export {
  getBeneficiaries,
  register,
  getPendingRequest,
  uploadFile,
  cancelRequest,
  acceptRequest,
  rejectRequest,
  getUploadedDocumentRequest,
  getAllRequest
}